import { VisualizationsInfoCompaniesManagement } from "./VisualizationsInfoCompaniesManagement";

export const VisualizationsCompaniesManagement = (theme) => {
    let colors = {};

    if (theme == "dark") {
        colors = {
            cyan: "#2BB5BA",
            yellow: "#E67E00",
            yellowDark: "#FFB700",
            cyanDark: "#00D2D9",
            cyanDarker: "#00B9BF",
            cyanLighter: "#66FAFF",
            violet: "#4E0389",
            yellowMedium: "#FFE200",
            purpleDark: "#B500D9",
            grayLight: "#99B6CC",
            basicDark: "#2E5573",
            medal: "#cd7f32"
        };
    } else {
        colors = {
            cyan: "#30CED4",
            yellow: "#F0883E",
            yellowDark: "#E3B341",
            cyanDark: "#0F9499",
            cyanDarker: "#2BB5BA",
            cyanLighter: "#73E2E6",
            violet: "#450D70",
            yellowMedium: "#E6CD17",
            purpleDark: "#A371F7",
            grayLight: "#A5A6A7",
            basicDark: "#516b9e",
            medal: "#cd7f32"
        };
    }

    return [
        {
            _id: "chart_score",
            bindings: {
                chartTitle: "Nucont Score",
                kpiValue: true,
                description:
                    VisualizationsInfoCompaniesManagement["chart_score"]
                        .description,
                formula:
                    VisualizationsInfoCompaniesManagement["chart_score"]
                        .formula,
                drillDown:
                    VisualizationsInfoCompaniesManagement["chart_score"]
                        .drillDown
            },
            component:
                "<chart-visualization-score-component chart-height='400px' accounting-id='$$.accountingId' current-date='$$.currentDate' visualization-id='$$.visualizationId' current-filters='$$.currentFilters' on-open-showtime='$$.onOpenShowtime({ visualizationId })'></chart-visualization-score-component>"
        },
        {
            _id: "chart_score_distribution",
            bindings: {
                chartTitle: "Distribuição do Score (clientes ativos)",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "pie",
                    chart: {
                        reflow: true,
                        type: "pie"
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: "pointer",
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [
                        {
                            _id: "SCORE_ACCOUNTING_HIGH",
                            color: "cyan.dark",
                            name: "Alto",
                            type: "pie"
                        },
                        {
                            _id: "SCORE_ACCOUNTING_MEDIUM",
                            color: "yellow.medium",
                            name: "Médio",
                            type: "pie"
                        },
                        {
                            _id: "SCORE_ACCOUNTING_LOW",
                            color: "purple.medium",
                            name: "Baixos",
                            type: "pie"
                        }
                    ],
                    yAxis: {
                        plotLines: [
                            {
                                color: "#000",
                                value: 0,
                                width: 1,
                                zIndex: 6
                            }
                        ],
                        title: {
                            text: ""
                        }
                    },
                    legend: {
                        labelFormat: "{name} ({percentage:.1f}%)"
                    }
                },
                series: [
                    {
                        _id: "SCORE_ACCOUNTING_HIGH",
                        type: "pie",
                        color: colors.cyan
                    },
                    {
                        _id: "SCORE_ACCOUNTING_MEDIUM",
                        type: "pie",
                        color: colors.yellow
                    },
                    {
                        _id: "SCORE_ACCOUNTING_LOW",
                        type: "pie",
                        color: colors.purpleDark
                    }
                ],

                kpiValue: false
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' kpi-value='$$.bindings.kpiValue' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "customers_engagement",
            bindings: {
                chartTitle: "Engajamento com os clientes",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            _id: "CUSTOMER_ENGAGEMENT_INSERTED",
                            color: "purple.light",
                            name: "Inseriu dados",
                            type: "line"
                        },
                        {
                            _id: "CUSTOMER_ENGAGEMENT_SHARED",
                            color: "purple.medium",
                            name: "Compartilhou Relatório",
                            type: "line"
                        },
                        {
                            _id: "CUSTOMER_ENGAGEMENT_DOWNLOADED",
                            color: "purple.medium",
                            name: "Baixou Relatório",
                            type: "line"
                        },
                        {
                            _id: "CUSTOMER_ENGAGEMENT_VIEWED",
                            color: "purple.dark",
                            name: "Visualizou Relatório",
                            type: "line"
                        }
                    ],
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                format: "{value}"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                series: [
                    {
                        _id: "CUSTOMER_ENGAGEMENT_INSERTED",
                        type: "line"
                    },
                    {
                        _id: "CUSTOMER_ENGAGEMENT_SHARED",
                        type: "line"
                    },
                    {
                        _id: "CUSTOMER_ENGAGEMENT_DOWNLOADED",
                        type: "line"
                    },
                    {
                        _id: "CUSTOMER_ENGAGEMENT_VIEWED",
                        type: "line"
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "score_overview",
            bindings: {
                chartTitle: "Nucont Score Geral",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            type: "line",
                            _id: "SCORE_ACCOUNTING",
                            color: "black.lightness",
                            unit: "int",
                            yAxis: 0
                        }
                    ],
                    legend: {
                        useHTML: true,
                        symbolWidth: 0,
                        labelFormatter: function () {
                            return (
                                "<div>" +
                                '<div style="border-radius: 50%; position: relative; top: 1px; width: 12px; height: 12px; marign-right: 5px; background-color: ' +
                                "#00b9bf" +
                                '; display: inline-block;"> </div>' +
                                "<span style='color:" +
                                "#757575" +
                                "; font-family:Open Sans'> " +
                                "Alto" +
                                " </span>" +
                                '<div style="border-radius: 50%; position: relative; top: 1px; width: 12px; height: 12px; marign-right: 5px; margin-left: 8px; background-color: ' +
                                "#ffb700" +
                                '; display: inline-block;"> </div>' +
                                "<span style='color:" +
                                "#757575" +
                                "; font-family:Open Sans'> " +
                                "Médio" +
                                " </span>" +
                                '<div style="border-radius: 50%; position: relative; top: 1px; width: 12px; height: 12px; marign-right: 5px; margin-left: 8px; background-color: ' +
                                "#b500d9" +
                                '; display: inline-block;"> </div>' +
                                "<span style='color:" +
                                "#757575" +
                                "; font-family:Open Sans'> " +
                                "Baixo" +
                                " </span>" +
                                " </div> "
                            );
                        }
                    },
                    plotOptions: {
                        series: {
                            lineWidth: 3,
                            marker: { radius: 7 },
                            events: {
                                legendItemClick: function (e) {
                                    e.preventDefault();
                                }
                            }
                        }
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                format: "{value}"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                kpiValue: true,
                series: [
                    {
                        _id: "SCORE_ACCOUNTING",
                        type: "line",
                        unit: "int",
                        marker: {
                            enabledThreshold: 0
                        },
                        dashStyle: "dash"
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters' kpi-value='$$.bindings.kpiValue'></chart-structure-component>"
        },
        {
            _id: "chart_score_detailed",
            bindings: {
                chartTitle: "Score detalhado",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            _id: "SCORE_ACCOUNTING_HIGH",
                            color: "cyan.dark",
                            name: "Alto",
                            type: "line"
                        },
                        {
                            _id: "SCORE_ACCOUNTING_MEDIUM",
                            color: "yellow.medium",
                            name: "Médio",
                            type: "line"
                        },
                        {
                            _id: "SCORE_ACCOUNTING_LOW",
                            color: "purple.medium",
                            name: "Baixos",
                            type: "line"
                        }
                    ],
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                format: "{value}%"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                series: [
                    {
                        _id: "SCORE_ACCOUNTING_HIGH",
                        type: "line",
                        color: colors.cyan
                    },
                    {
                        _id: "SCORE_ACCOUNTING_MEDIUM",
                        type: "line",
                        color: colors.yellow
                    },
                    {
                        _id: "SCORE_ACCOUNTING_LOW",
                        type: "line",
                        color: colors.purpleDark
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_fees",
            bindings: {
                chartTitle: "Honorários",
                structure: {
                    chart: { reflow: true, type: "column" },
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    legend: { enabled: false },
                    yAxis: [
                        {
                            plotLines: [{ width: 1, value: 0, zIndex: 6 }],
                            labels: { enabled: true },
                            title: { enabled: false }
                        }
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {},
                    series: [
                        {
                            _id: "SUM_FEES_BY_MONTH",
                            color: "cyan.dark",
                            name: "Honorário",
                            type: "column"
                        }
                    ]
                },
                series: [
                    {
                        _id: "SUM_FEES_BY_MONTH",
                        type: "column",
                        color: colors.cyan
                    }
                ],
                kpiValue: true
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' kpi-value='$$.bindings.kpiValue' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_average_ticket",
            bindings: {
                chartTitle: "Ticket Médio",
                structure: {
                    chart: { reflow: true, type: "column" },
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    legend: { enabled: false },
                    yAxis: [
                        {
                            plotLines: [{ width: 1, value: 0, zIndex: 6 }],
                            labels: { enabled: true },
                            title: { enabled: false }
                        }
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {},
                    series: [
                        {
                            _id: "SUM_AVARAGETICKET_BY_MONTH",
                            color: "cyan.dark",
                            name: "Ticket médio",
                            type: "column"
                        }
                    ]
                },
                series: [
                    {
                        _id: "SUM_AVARAGETICKET_BY_MONTH",
                        type: "column",
                        color: colors.cyan
                    }
                ],
                kpiValue: true
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' kpi-value='$$.bindings.kpiValue' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_billing_risk",
            bindings: {
                chartTitle: "Faturamento por Score",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    chart: { reflow: true, type: "column" },
                    category: "column",
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            plotLines: [{ width: 1, value: 0, zIndex: 6 }],
                            labels: { enabled: true },
                            title: { enabled: false }
                        }
                    ],
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {},
                    series: [
                        {
                            _id: "SUM_BILLING_RISK_HIGH",
                            color: "cyan.dark",
                            name: "Score Baixo",
                            type: "column",
                            unit: "currency"
                        },
                        {
                            _id: "SUM_BILLING_RISK_MEDIUM",
                            color: "yellow.dark",
                            name: "Score Baixo",
                            type: "column",
                            unit: "currency"
                        },
                        {
                            _id: "SUM_BILLING_RISK_LOW",
                            color: "purple.dark",
                            name: "Score Baixo",
                            type: "column",
                            unit: "currency"
                        }
                    ]
                },
                series: [
                    {
                        _id: "SUM_BILLING_RISK_HIGH",
                        type: "column",
                        color: colors.cyanDark,
                        unit: "currency"
                    },
                    {
                        _id: "SUM_BILLING_RISK_MEDIUM",
                        type: "column",
                        color: colors.yellowDark,
                        unit: "currency"
                    },
                    {
                        _id: "SUM_BILLING_RISK_LOW",
                        type: "column",
                        color: colors.purpleDark,
                        unit: "currency"
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' kpi-value='$$.bindings.kpiValue' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "companies_table_managment",
            bindings: {
                fields: [
                    "name",
                    "fees",
                    "score",
                    "last_input",
                    "report_shareds_vieweds_comments"
                ]
            },
            component:
                "<companies-table-management-component accounting-data='$$.accountingData' accounting-plan-entity='$$.accountingPlanEntity' accounting-id='$$.accountingId' fields='$$.bindings.fields' current-date='$$.currentDate' current-filters='$$.currentFilters'></companies-table-management-component>"
        },
        {
            _id: "companies_table_managment_without_score",
            bindings: {
                fields: [
                    "name",
                    "fees",
                    "last_input",
                    "report_shareds_vieweds_comments"
                ]
            },
            component:
                "<companies-table-management-component accounting-data='$$.accountingData' accounting-id='$$.accountingId' fields='$$.bindings.fields' current-date='$$.currentDate' current-filters='$$.currentFilters'></companies-table-management-component>"
        },
        {
            _id: "chart_customers",
            bindings: {
                chartTitle: "Nº de Clientes",
                structure: {
                    chart: { reflow: true, type: "column" },
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    legend: { enabled: false },
                    yAxis: [
                        {
                            plotLines: [{ width: 1, value: 0, zIndex: 6 }],
                            labels: { enabled: true },
                            title: { enabled: false }
                        }
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series: [
                    {
                        _id: "COUNT_COMPANIES_BY_MONTH",
                        type: "column",
                        color: colors.cyan
                    }
                ],
                kpiValue: true
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' kpi-value='$$.bindings.kpiValue' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_customers_fees_tax_polity",
            bindings: {
                chartTitle:
                    "Nº de Clientes por Regime de Tributação e Honorários",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: true },
                    yAxis: [
                        {
                            labels: {
                                enabled: true
                            },
                            title: {
                                text: ""
                            }
                        },
                        {
                            title: {
                                text: ""
                            },
                            labels: {
                                enabled: true
                            },
                            opposite: true
                        }
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter,
                        colors.violet,
                        colors.yellowMedium
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                combinationSeries: [
                    {
                        _id: "SUM_FEES_BY_TAXATION_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ],
                series:
                    "this.group({'field': 'taxation', 'baseId': 'COUNT_CUSTOMERS_COMPANIES_GROUP_TAXATION', 'unit': 'number', 'refereceId': 'COUNT_COMPANIES_BY_GROUP_TAXATION', func: 'countBy', customStructure: { yAxis: 1, zIndex: 1 }})"
                // series: [
                //     {
                //         _id: "COUNT_COMPANIES_BY_TAXATION_MONTH",
                //         type: "column",
                //         yAxis: 1,
                //         zIndex: 1,
                //         color: colors.cyanDark
                //     },
                //     {
                //         _id: "SUM_FEES_BY_TAXATION_MONTH",
                //         type: "line",
                //         yAxis: 0,
                //         zIndex: 2,
                //         color: color.yellowDark,
                //         marker: {
                //             fillColor: "white",
                //             lineColor: "rgb(249,192, 44)",
                //             lineWidth: 2
                //         }
                //     }
                // ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "companies_table_managment_tax_polity",
            bindings: {
                mainColumnTitle: "Regime de Tributação",
                mainColumnName: "taxation"
            },
            component:
                "<table-data-aggregate-component accounting-id='$$.accountingId' main-column-title='$$.bindings.mainColumnTitle' main-column-name='$$.bindings.mainColumnName' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-aggregate-component>"
        },
        {
            _id: "chart_data_percentage_tax_polity",
            bindings: {
                chartTitle: "(%) da Base por Regime de Tributação",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter,
                        colors.violet,
                        colors.yellowMedium
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'taxation', 'baseId': 'COUNT_PECENTAGE_COMPANIES_GROUP_TAXATION'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_deliveries_tax_polity",
            bindings: {
                chartTitle: "Nº de Entregas por Regime de Tributação",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter,
                        colors.violet,
                        colors.yellowMedium
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },

                series:
                    "this.group({'field': 'taxation', 'baseId': 'COUNT_DELIVERYS_COMPANIES_GROUP_TAXATION', 'unit': 'number', 'func': 'countByDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_customers_fees_segment",
            bindings: {
                chartTitle: "Nº de Clientes por Grupo de Segmento e Honorários",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: true },
                    yAxis: [
                        {
                            labels: {
                                style: {},
                                enabled: true
                            },
                            title: {
                                text: "",
                                style: {}
                            }
                        },
                        {
                            title: {
                                text: "",
                                style: {}
                            },
                            labels: {
                                style: {},
                                enabled: true
                            },
                            opposite: true
                        }
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                combinationSeries: [
                    {
                        _id: "SUM_FEES_BY_SEGMENTGROUP_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ],
                series:
                    "this.group({'field': 'segmentGroup', 'baseId': 'COUNT_CUSTOMERS_COMPANIES_GROUP_SEGMENTGROUP', 'unit': 'number', 'refereceId': 'COUNT_COMPANIES_BY_GROUP_SEGMENTGROUP', func: 'countBy', customStructure: { yAxis: 1, zIndex: 1 }})"
                // series: [
                //     {
                //         _id: "COUNT_COMPANIES_BY_SEGMENTGROUP_MONTH",
                //         type: "column",
                //         yAxis: 1,
                //         zIndex: 1,
                //         color: colors.cyanDark
                //     }
                // ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "companies_table_managment_segment",
            bindings: {
                mainColumnTitle: "Grupo de Segmento",
                mainColumnName: "segmentGroup"
            },
            component:
                "<table-data-aggregate-component accounting-id='$$.accountingId' main-column-title='$$.bindings.mainColumnTitle' main-column-name='$$.bindings.mainColumnName' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-aggregate-component>"
        },
        {
            _id: "chart_data_percentage_segment",
            bindings: {
                chartTitle: "(%) da Base por Grupo de Segmento",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'segmentGroup', 'baseId': 'COUNT_PECENTAGE_COMPANIES_GROUP_SEGMENTGROUP', 'func': 'countPercentage'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_deliveries_segment",
            bindings: {
                chartTitle: "Nº de Entregas por Grupo de Segmento",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'segmentGroup', 'baseId': 'COUNT_DELIVERYS_COMPANIES_GROUP_SEGMENTGROUP', 'unit': 'number', 'func': 'countByDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_customers_fees_category",
            bindings: {
                chartTitle: "Nº de Clientes por Categoria e Honorários",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: true },
                    yAxis: [
                        {
                            labels: {
                                style: {},
                                enabled: true
                            },
                            title: {
                                text: "",
                                style: {}
                            }
                        },
                        {
                            title: {
                                text: "",
                                style: {}
                            },
                            labels: {
                                style: {},
                                enabled: true
                            },
                            opposite: true
                        }
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.cyanDarker,
                        colors.yellowDark,
                        colors.purpleDark,
                        colors.grayLight
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                combinationSeries: [
                    {
                        _id: "SUM_FEES_BY_CATEGORY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ],
                series:
                    "this.group({'field': 'category', 'baseId': 'COUNT_CUSTOMERS_COMPANIES_GROUP_CATEGORY', 'unit': 'number', 'refereceId': 'COUNT_COMPANIES_BY_GROUP_CATEGORY', func: 'countBy', customStructure: { yAxis: 1, zIndex: 1 }})"
                // series: [
                //     {
                //         _id: "COUNT_COMPANIES_BY_CATEGORY_MONTH",
                //         type: "column",
                //         yAxis: 1,
                //         zIndex: 1,
                //         color: colors.cyanDark
                //     },
                //     {
                //         _id: "SUM_FEES_BY_CATEGORY_MONTH",
                //         type: "line",
                //         yAxis: 0,
                //         zIndex: 2,
                //         color: color.yellowDark,
                //         marker: {
                //             fillColor: "white",
                //             lineColor: "rgb(249,192, 44)",
                //             lineWidth: 2
                //         }
                //     }
                // ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "companies_table_managment_category",
            bindings: {
                mainColumnTitle: "Categoria",
                mainColumnName: "category"
            },
            component:
                "<table-data-aggregate-component accounting-id='$$.accountingId' main-column-title='$$.bindings.mainColumnTitle' main-column-name='$$.bindings.mainColumnName' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-aggregate-component>"
        },
        {
            _id: "chart_data_percentage_category",
            bindings: {
                chartTitle: "(%) da Base por Categoria",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.cyanDarker,
                        colors.yellowDark,
                        colors.purpleDark,
                        colors.grayLight
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'category', 'baseId': 'COUNT_PECENTAGE_COMPANIES_GROUP_CATEGORY', 'func': 'countPercentage'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_deliveries_category",
            bindings: {
                chartTitle: "Nº de Entregas por Categoria",
                structure: {
                    category: "column",
                    plotOptions: {
                        series: {}
                    },
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.cyanDarker,
                        colors.yellowDark,
                        colors.purpleDark,
                        colors.grayLight
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'category', 'baseId': 'COUNT_DELIVERYS_COMPANIES_GROUP_CATEGORY', 'unit': 'number', 'func': 'countByDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "companies_table_managment_deliveries",
            bindings: {
                fields: [
                    "deliveries",
                    "accounting",
                    "financial",
                    "tax",
                    "personnel"
                ]
            },
            component:
                "<table-data-deliveries-by-days-component accounting-id='$$.accountingId' fields='$$.bindings.fields' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-deliveries-by-days-component>"
        },
        {
            _id: "chart_deliveries",
            bindings: {
                chartTitle: "Nº de Entregas",
                structure: {
                    category: "column",
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'source', 'baseId': 'COUNT_DELIVERYS_COMPANIES_GROUP_SOURCE', 'unit': 'number', 'func': 'countBySourceDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_data_percentage_deliveries",
            bindings: {
                chartTitle: "(%) da Base",
                structure: {
                    category: "column",
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    colors: [
                        colors.yellow,
                        colors.yellowDark,
                        colors.cyanDark,
                        colors.cyanLighter
                    ],
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'source', 'baseId': 'COUNT_PERCENTAGE_DELIVERYS_COMPANIES_GROUP_SOURCE', 'func': 'countPercentageBySourceDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "companies_table_managment_deliveries_type",
            bindings: {
                fields: ["deliveries_type", "jan", "fev", "mar", "abr"]
            },
            component:
                "<table-data-deliveries-by-sources-component accounting-id='$$.accountingId' fields='$$.bindings.fields' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-deliveries-by-sources-component>"
        },

        {
            _id: "chart_customers_fees_responsible",
            bindings: {
                chartTitle: "Nº de Clientes por Responsável e Honorários",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: false },
                    yAxis: [
                        {
                            labels: {
                                style: {},
                                enabled: true
                            },
                            title: {
                                text: "",
                                style: {}
                            }
                        },
                        {
                            title: {
                                text: "",
                                style: {}
                            },
                            labels: {
                                style: {},
                                enabled: true
                            },
                            opposite: true
                        }
                    ],
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                combinationSeries: [
                    {
                        _id: "SUM_FEES_BY_CATEGORY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ],
                series:
                    "this.group({'field': 'owner', 'baseId': 'COUNT_CUSTOMERS_COMPANIES_GROUP_OWNER', 'unit': 'number', 'refereceId': 'COUNT_COMPANIES_BY_GROUP_OWNER', func: 'countBy', customStructure: { yAxis: 1, zIndex: 1 }})"
                // series: [
                //     {
                //         _id: "COUNT_COMPANIES_BY_CATEGORY_MONTH",
                //         type: "column",
                //         yAxis: 1,
                //         zIndex: 1,
                //         color: colors.cyanDark
                //     },
                //     {
                //         _id: "SUM_FEES_BY_CATEGORY_MONTH",
                //         type: "line",
                //         yAxis: 0,
                //         zIndex: 2,
                //         color: color.yellowDark,
                //         marker: {
                //             fillColor: "white",
                //             lineColor: "rgb(249,192, 44)",
                //             lineWidth: 2
                //         }
                //     }
                // ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "companies_table_managment_responsible",
            bindings: {
                mainColumnTitle: "Responsável",
                mainColumnName: "owner"
            },
            component:
                "<table-data-aggregate-component accounting-id='$$.accountingId' main-column-title='$$.bindings.mainColumnTitle' main-column-name='$$.bindings.mainColumnName' current-date='$$.currentDate' current-filters='$$.currentFilters'></table-data-aggregate-component>"
        },
        {
            _id: "chart_data_percentage_responsible",
            bindings: {
                chartTitle: "(%) da Base por Responsável",
                structure: {
                    category: "column",
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    legend: { enabled: false },
                    tooltip: {}
                },
                series:
                    "this.group({'field': 'owner', 'baseId': 'COUNT_PECENTAGE_COMPANIES_GROUP_OWNER', 'func': 'countPercentage'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_deliveries_responsible",
            bindings: {
                chartTitle: "Nº de Entregas por Responsável",
                structure: {
                    category: "column",
                    labels: {
                        items: [
                            {
                                style: {
                                    color: "rgb(48, 206, 212)",
                                    left: "50px",
                                    top: "18px"
                                }
                            }
                        ]
                    },
                    yAxis: {
                        labels: { enabled: true },
                        title: { text: "" },
                        plotLines: [{ value: 0, width: 1 }]
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                            cursor: "pointer"
                        }
                    },
                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {},
                    legend: { enabled: false }
                },
                series:
                    "this.group({'field': 'owner', 'baseId': 'COUNT_DELIVERYS_COMPANIES_GROUP_OWNER', 'unit': 'number', 'func': 'countByDeliveryShared', 'refereceId': 'REPORT_SUM_SHARED_BY_MONTH'})"
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_total_average_revenue_customers",
            bindings: {
                chartTitle: "Total e Média de Receita dos clientes",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    plotOptions: {
                        series: {}
                    },
                    legend: { enabled: false },
                    yAxis: [
                        {
                            labels: {
                                enabled: true
                            },
                            title: {
                                text: ""
                            }
                        },
                        {
                            title: {
                                text: ""
                            },
                            labels: {
                                enabled: true
                            },
                            opposite: true
                        }
                    ],

                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series: [
                    {
                        _id: "TOTAL_RECEITAS_BY_MONTH",
                        type: "column",
                        yAxis: 1,
                        zIndex: 1,
                        color: colors.cyanDark
                    },
                    {
                        _id: "AVARAGE_RECEITAS_BY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_total_average_tax_paid_customers",
            bindings: {
                chartTitle: "Total e Média de Impostos Pagos dos Clientes",
                structure: {
                    plotOptions: {
                        series: {}
                    },
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: false },
                    yAxis: [
                        {
                            labels: {
                                enabled: true
                            },
                            title: {
                                text: ""
                            }
                        },
                        {
                            title: {
                                text: ""
                            },
                            labels: {
                                enabled: true
                            },
                            opposite: true
                        }
                    ],

                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series: [
                    {
                        _id: "TOTAL_IMPOSTOS_BY_MONTH",
                        type: "column",
                        yAxis: 1,
                        zIndex: 1,
                        color: colors.cyanDark
                    },
                    {
                        _id: "AVARAGE_IMPOSTOS_BY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_total_average_employees_customers",
            bindings: {
                chartTitle: "Total e Média de Funcionários dos Clientes",
                structure: {
                    plotOptions: {
                        series: {}
                    },
                    chart: { reflow: true },
                    category: "combinations",
                    legend: { enabled: false },
                    yAxis: [
                        {
                            labels: {
                                enabled: true
                            },
                            title: {
                                text: ""
                            }
                        },
                        {
                            title: {
                                text: ""
                            },
                            labels: {
                                enabled: true
                            },
                            opposite: true
                        }
                    ],

                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series: [
                    {
                        _id: "TOTAL_NUMERO_FUNCIONARIO_BY_MONTH",
                        type: "column",
                        yAxis: 1,
                        zIndex: 1,
                        color: colors.cyanDark
                    },
                    {
                        _id: "AVARAGE_NUMERO_FUNCIONARIO_BY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_total_revenue_customers_total_fees",
            bindings: {
                chartTitle:
                    "Total de Receita dos Clientes x Total de Honorários",
                structure: {
                    chart: { reflow: true },
                    category: "combinations",
                    plotOptions: {
                        series: {}
                    },
                    legend: { enabled: false },
                    yAxis: [
                        {
                            labels: {
                                enabled: true
                            },
                            title: {
                                text: ""
                            }
                        },
                        {
                            title: {
                                text: ""
                            },
                            labels: {
                                enabled: true
                            },
                            opposite: true
                        }
                    ],

                    title: { text: "" },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    xAxis: {
                        type: "datetime",
                        labels: {}
                    },
                    tooltip: {}
                },
                series: [
                    {
                        _id: "TOTAL_RECEITAS_BY_MONTH",
                        type: "column",
                        yAxis: 1,
                        zIndex: 1,
                        color: colors.cyanDark
                    },
                    {
                        _id: "SUM_FEES_BY_MONTH",
                        type: "line",
                        yAxis: 0,
                        zIndex: 2,
                        color: colors.yellowDark,
                        marker: {
                            fillColor: "white",
                            lineColor: "rgb(249,192, 44)",
                            lineWidth: 2
                        }
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_billing_accountings",
            bindings: {
                chartTitle: "Faturamento Nucont",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            _id: "BILLING_ACCOUNTINGS_HIGH",
                            color: "cyan.dark",
                            name: "Score Alto",
                            type: "line"
                        },
                        {
                            _id: "BILLING_ACCOUNTINGS_MEDIUM",
                            color: "yellow.medium",
                            name: "Score Médio",
                            type: "line"
                        },
                        {
                            _id: "BILLING_ACCOUNTINGS_LOW",
                            color: "purple.medium",
                            name: "Score Baixo",
                            type: "line"
                        }
                    ],
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                formatter: function () {
                                    function kFormatter(num) {
                                        if (Math.abs(num) < 1e6)
                                            return (
                                                Math.sign(num) *
                                                    (
                                                        Math.abs(num) / 1e3
                                                    ).toFixed(1) +
                                                "k"
                                            );
                                        else if (Math.abs(num) >= 1e6)
                                            return (
                                                Math.sign(num) *
                                                    (
                                                        Math.abs(num) / 1e6
                                                    ).toFixed(1) +
                                                "M"
                                            );
                                    }

                                    if (Math.abs(this.value) > 999)
                                        return "R$ " + kFormatter(this.value);
                                    return this.value.toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL"
                                    });
                                }
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                series: [
                    {
                        _id: "BILLING_ACCOUNTINGS_HIGH",
                        type: "line",
                        color: colors.cyan
                    },
                    {
                        _id: "BILLING_ACCOUNTINGS_MEDIUM",
                        type: "line",
                        color: colors.yellow
                    },
                    {
                        _id: "BILLING_ACCOUNTINGS_LOW",
                        type: "line",
                        color: colors.purpleDark
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },

        {
            _id: "chart_score_accountings",
            bindings: {
                chartTitle: "Nucont score geral",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            _id: "SCORE_ACCOUNTINGS_HIGH",
                            color: "cyan.dark",
                            name: "Score Alto",
                            type: "line"
                        },
                        {
                            _id: "SCORE_ACCOUNTINGS_MEDIUM",
                            color: "yellow.medium",
                            name: "Score Médio",
                            type: "line"
                        },
                        {
                            _id: "SCORE_ACCOUNTINGS_LOW",
                            color: "purple.medium",
                            name: "Score Baixo",
                            type: "line"
                        }
                    ],
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                format: "{value}"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                series: [
                    {
                        _id: "SCORE_ACCOUNTINGS_HIGH",
                        type: "line",
                        color: colors.cyan
                    },
                    {
                        _id: "SCORE_ACCOUNTINGS_MEDIUM",
                        type: "line",
                        color: colors.yellow
                    },
                    {
                        _id: "SCORE_ACCOUNTINGS_LOW",
                        type: "line",
                        color: colors.purpleDark
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        },
        {
            _id: "chart_impact_accountings",
            bindings: {
                chartTitle: "Programa de parceria",
                structure: {
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    title: { text: "" },
                    category: "line",
                    chart: {
                        type: "line",
                        reflow: true
                    },
                    series: [
                        {
                            _id: "IMPACT_ACCOUNTINGS_BRONZE",
                            color: "purple.dark",
                            name: "Bronze",
                            type: "line"
                        },
                        {
                            _id: "IMPACT_ACCOUNTINGS_PRATA",
                            color: "cyan.medium",
                            name: "Prata",
                            type: "line"
                        },
                        {
                            _id: "IMPACT_ACCOUNTINGS_OURO",
                            color: "yellow.dark",
                            name: "Ouro",
                            type: "line"
                        },
                        {
                            _id: "IMPACT_ACCOUNTINGS_EMBAIXADOR",
                            color: "basic.dark",
                            name: "Ouro",
                            type: "line"
                        }
                    ],
                    legend: {
                        enabled: true
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: true,
                                format: "{value}"
                            },
                            title: {
                                text: ""
                            },
                            plotLines: [
                                {
                                    color: "#000",
                                    width: 1,
                                    value: 0
                                }
                            ]
                        }
                    ]
                },
                series: [
                    {
                        _id: "IMPACT_ACCOUNTINGS_BRONZE_TOTAL",
                        type: "line",
                        opacity: 1,
                        color: colors.medal
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_BRONZE_0",
                        type: "line",
                        opacity: 0.5,
                        color: colors.medal
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_BRONZE_1",
                        type: "line",
                        opacity: 0.7,
                        color: colors.medal
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_BRONZE_2",
                        type: "line",
                        color: colors.medal,
                        opacity: 0.8
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_PRATA",
                        type: "line",
                        color: colors.cyan
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_OURO",
                        type: "line",
                        color: colors.yellowDark
                    },
                    {
                        _id: "IMPACT_ACCOUNTINGS_EMBAIXADOR",
                        type: "line",
                        color: colors.basicDark
                    }
                ]
            },
            component:
                "<chart-structure-component accounting-id='$$.accountingId' structure='$$.bindings.structure' series='$$.bindings.series' combination-series='$$.bindings.combinationSeries' chart-title='$$.bindings.chartTitle' current-date='$$.currentDate' current-filters='$$.currentFilters'></chart-structure-component>"
        }
    ];
};
